import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { useFirebase } from "../../FbContex";
import { Widget } from "../../enum";
import { widgetOf } from "../../lib/node";
import Readout from "./Readout";
import Gauge from "./Gauge";
import SliderWidget from "./SliderWidget";
import Buttons from "./Buttons";
import ColorWidget from "./ColorWidget";
import AcWidget from "./AcWidget";
import ParamInputs from "./ParamInputs";
import UnknownWidget from "./UnknownWidget";

/** The only file that switches on widget. Everything else stays dumb. */
function Body({ node, ctx }: { node: INode; ctx: ServiceContextType }) {
  switch (widgetOf(node)) {
    case Widget.READOUT:
      return <Readout node={node} ctx={ctx} />;
    case Widget.GAUGE:
      return <Gauge node={node} ctx={ctx} />;
    case Widget.SLIDER:
      return <SliderWidget node={node} ctx={ctx} />;
    case Widget.BUTTONS:
      return <Buttons node={node} ctx={ctx} />;
    case Widget.COLOR:
      return <ColorWidget node={node} ctx={ctx} />;
    case Widget.AC:
      return <AcWidget node={node} ctx={ctx} />;
    case Widget.NONE:
      return null;
    default:
      // Covers both an unset widget and anything written straight into RTDB.
      return <UnknownWidget node={node} />;
  }
}

export default function DeviceWidget({ node }: { node: INode }) {
  const ctx = useFirebase() as ServiceContextType;

  return (
    // `relative` so the AC running badge stays inside the card -- it used to
    // escape, because nothing in the chain established a positioning context.
    <div className="relative bg-stone-100/90 dark:bg-stone-800/90 mb-4 p-4 rounded-lg">
      <div className="flex flex-row space-x-2 text-stone-500 items-center">
        {node.icon && <i className={`fas fa-${node.icon}`} />}
        <div className="font-bold">{node.title}</div>
      </div>
      <Body node={node} ctx={ctx} />
      <ParamInputs node={node} ctx={ctx} />
    </div>
  );
}
